import { AllCommunityModule, ModuleRegistry, provideGlobalGridOptions } from 'ag-grid-community';
import { StartupService } from './core/services/startup.service';

ModuleRegistry.registerModules([AllCommunityModule]);
provideGlobalGridOptions({ theme: 'legacy' });

export function onStartup(startupService: StartupService): () => Promise<boolean> {
  return () => {
    return new Promise((resolve) => {
      startupService.init().subscribe(() => resolve(true));
    });
  };
}
